import { Editor } from "../editor/Editor";
import { Viewer } from "../editor/Viewer";
import isReportLocked from "../../../../helpers/liveReportHelpers/isReportLocked";

/**
 * @typedef {import('../../../../types/LiveReports2').LiveReports2Doc} LiveReports2Doc
 * @typedef {import('../widgets').BaseWidget} BaseWidget
 */

/**
 * Het werkvlak van de rapportbouwer: de editor, of bij een vergrendeld rapport
 * de alleen-lezen weergave. Nodig omdat de bouwer anders ook een vergrendeld
 * rapport in de editor opent, met slepen, verwijderen en instellingen.
 *
 * AI-CONTEXT: See docs/features/meetstandaardrapportage.md (T1b, besluit B4)
 *
 * @param {object} props
 * @param {LiveReports2Doc} props.report - Het geopende rapport (al geladen)
 * @param {BaseWidget[]} props.widgets - De widgets van het rapport, voor de alleen-lezen weergave
 */
const ReportBuilderBody = ({ report, widgets }) => {
    if (!isReportLocked(report)) {
        return <Editor />;
    }

    return (
        <div className="report-builder-locked">
            <p className="report-builder-locked-notice">
                Deze rapportage is vergrendeld. Je kunt de periode kiezen, publiceren en delen, maar de opbouw niet wijzigen.
            </p>
            <Viewer widgets={widgets} />
        </div>
    );
};

export default ReportBuilderBody;
